import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth-context";
import { formatApiErrorDetail } from "../lib/api";
import { FormPrivacyNote } from "../components/FormPrivacyNote";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      await register(form);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  const input = "w-full rounded-sm border border-stone-300 bg-white px-4 py-3 text-sm font-sans focus:outline-none focus:ring-2 focus:ring-bronze-dark/40 focus:border-bronze-dark";
  return (
    <div data-testid="register-page" className="container-ccc py-16 max-w-md">
      <div className="eyebrow">Create your account</div>
      <h1 className="font-serif text-4xl mt-3">Patient portal sign-up.</h1>
      <p className="mt-3 text-ink-muted text-sm">Creating an account lets you track enquiries and access future appointments.</p>
      <form onSubmit={submit} data-testid="register-form" className="mt-10 space-y-5">
        <div>
          <label className="block text-xs uppercase tracking-[0.18em] text-ink-muted mb-2">Full name</label>
          <input required data-testid="register-name-input" className={input} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
        </div>
        <div>
          <label className="block text-xs uppercase tracking-[0.18em] text-ink-muted mb-2">Email</label>
          <input required type="email" data-testid="register-email-input" className={input} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </div>
        <div>
          <label className="block text-xs uppercase tracking-[0.18em] text-ink-muted mb-2">Password (min. 8 characters)</label>
          <input required type="password" minLength={8} data-testid="register-password-input" className={input} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        </div>
        {error && <div data-testid="register-error" className="text-sm text-destructive">{error}</div>}
        <button disabled={loading} type="submit" data-testid="register-submit-button" className="btn-primary w-full">{loading ? "Creating…" : "Create account"}</button>
        <FormPrivacyNote />
      </form>
      <div className="mt-6 text-sm text-ink-muted">
        Already have an account? <Link to="/login" className="text-bronze-dark">Sign in</Link>
      </div>
    </div>
  );
}
